module.exports = __webpack_public_path__ + "cloud-4.svg?7dbe48a56ab8457075d51ac17d706c38";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud-4.svg
// module id = 155
// module chunks = 0